import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { BACKGROUND_COLOR_CLASS } from '../../../utils/getColorClass.js';
import { useResize, getResponsiveClass } from '../../../utils/breakpoints.js';
import styles from './index.module.scss.js';

const Box = ({ as: Component = 'div', children, backgroundColor, border, borderRadius, elevation, p, px, py, pl, pr, pt, pb, m, mx, my, ml, mr, mt, mb, 
// Allow this component to have external styles.
// Only applied to this component as it will be used as a wrapper.
// eslint-disable-next-line no-restricted-syntax
className, 
// eslint-disable-next-line no-restricted-syntax
...props }) => {
    var _a;
    const resize = useResize();
    const i = (_a = resize[2]) === null || _a === void 0 ? void 0 : _a.index;
    const paddingClasses = [
        styles[getResponsiveClass(p, 'p', i)],
        styles[getResponsiveClass(px, 'pl', i)],
        styles[getResponsiveClass(px, 'pr', i)],
        styles[getResponsiveClass(py, 'pt', i)],
        styles[getResponsiveClass(py, 'pb', i)],
        styles[getResponsiveClass(pl, 'pl', i)],
        styles[getResponsiveClass(pr, 'pr', i)],
        styles[getResponsiveClass(pt, 'pt', i)],
        styles[getResponsiveClass(pb, 'pb', i)],
    ].filter(Boolean);
    const marginClasses = [
        styles[getResponsiveClass(m, 'm', i)],
        styles[getResponsiveClass(mx, 'ml', i)],
        styles[getResponsiveClass(mx, 'mr', i)],
        styles[getResponsiveClass(my, 'mt', i)],
        styles[getResponsiveClass(my, 'mb', i)],
        styles[getResponsiveClass(ml, 'ml', i)],
        styles[getResponsiveClass(mr, 'mr', i)],
        styles[getResponsiveClass(mt, 'mt', i)],
        styles[getResponsiveClass(mb, 'mb', i)],
    ].filter(Boolean);
    return (jsx(Component, { className: classNames(backgroundColor && BACKGROUND_COLOR_CLASS[backgroundColor], border && styles.border, borderRadius && styles[`borderRadius__${borderRadius}`], elevation && styles.elevation, ...paddingClasses, ...marginClasses, className), ...props, children: children }));
};

export { Box };
